// start:ng42.barrel
export * from './reservation-change.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/change/index.ts